import React, { useState } from 'react'

//MUI
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from '@mui/material'
import { NewOldWebFormValidator } from '../../../validators/NewWebFormValidator'

const init = {
    title: '',
    date: '',
    speaker: '',
    iframe: '',
}

const AddOldWebinar = ({ openDialog, setOpenDialog }) => {
    const [data, setData] = useState(init)

    const handleChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        });
    };

    const handleCloseDialog = () => {
        setOpenDialog(false)
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (NewOldWebFormValidator(data)) {
            const load = JSON.parse(localStorage.getItem('oldWebinars')) || [];

            const newForm = {
                id: Date.now(),
                ...data,
            };

            load.push(newForm);
            localStorage.setItem('oldWebinars', JSON.stringify(load));
            setData(init);
            setOpenDialog(false)
            alert('Guardado old webinar en localstorage');
        }
    };

    const isYoutubeEmbed = (url) => {
        return /^https:\/\/www\.youtube\.com\/embed\//.test(url);
    };

    return (
        <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth='md' fullWidth>
            <DialogTitle>Añadir webinar anterior</DialogTitle>
            <DialogContent>
                <Grid container spacing={4}>
                    <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Titulo</Typography>
                        <TextField
                            fullWidth
                            name="title"
                            value={data.title}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xxl={5} xl={5} lg={5} md={6} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Fecha</Typography>
                        <TextField
                            fullWidth
                            type="date"
                            name="date"
                            InputLabelProps={{ shrink: true }}
                            value={data.date}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xxl={7} xl={7} lg={7} md={6} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Ponente</Typography>
                        <TextField
                            fullWidth
                            name="speaker"
                            value={data.speaker}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <Typography variant='body1' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Enlace embebido de youtube</Typography>
                        <TextField
                            fullWidth
                            name="iframe"
                            value={data.iframe}
                            onChange={handleChange}
                        />
                    </Grid>
                    {
                        isYoutubeEmbed(data.iframe) &&
                        <Grid item xs={12}>
                            <Typography variant='body2' sx={{ fontWeight: '500', color: '#707b7c', mb: .5 }}>Vista previa:</Typography>
                            <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '8px' }}>
                                <iframe
                                    src={data.iframe}
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                    title="OldWebinar"
                                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                ></iframe>
                            </div>
                        </Grid>
                    }
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog}>Cancelar</Button>
                <Button variant='contained' onClick={handleSubmit}>Añadir</Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddOldWebinar